import { render, staticRenderFns } from "./LianJianLabelDialog.vue?vue&type=template&id=544ecb76&scoped=true"
import script from "./LianJianLabelDialog.vue?vue&type=script&lang=js"
export * from "./LianJianLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./LianJianLabelDialog.vue?vue&type=style&index=0&id=544ecb76&prod&scoped=true&lang=css"
import style1 from "./LianJianLabelDialog.vue?vue&type=style&index=1&id=544ecb76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544ecb76",
  null
  
)

export default component.exports